import React, { useEffect } from 'react';
import { useReminders } from './ReminderContext';


const ReminderWrapper = ({ children }) => {
  const { checkSessionStorageAndReminders } = useReminders();

  useEffect(() => {
    console.log('ReminderWrapper: Component mounted, setting up interval');
    
    // Check reminders every 15 seconds for more frequent updates
    const intervalId = setInterval(() => {
      console.log('ReminderWrapper: Interval triggered - checking reminders');
      checkSessionStorageAndReminders();
    }, 15000);

    // Also check immediately when component mounts
    console.log('ReminderWrapper: Initial reminder check');
    checkSessionStorageAndReminders();

    return () => {
      console.log('ReminderWrapper: Cleaning up interval');
      clearInterval(intervalId);
    };
  }, [checkSessionStorageAndReminders]);

  return <>{children}</>;
};

export default ReminderWrapper;